import { Alert } from '@material-ui/lab';
import { useShowSnackbar } from 'components/main/SnackbarProvider';
import { ADMIN_USERS } from 'constants/adminUsers';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { signIn } from 'services/AccountService';
import { Context } from './context';
import { setUserFunc } from './types';

export function useUser() {
  return useContext(Context).user;
}

export function useSetUser(): setUserFunc {
  return useContext(Context).setUser as setUserFunc;
}

export function useIsAdminUser(): boolean {
  return ADMIN_USERS.includes(useContext(Context).user?.uid as string);
}

export function useIsUserLoggedIn() {
  return useContext(Context).user !== null;
}

export function useLogin() {
  const showSnackbar = useShowSnackbar();
  const history = useHistory();
  const setUser = useSetUser();

  async function handleLogin() {
    try {
      const credentials = await signIn();

      if (!credentials) {
        showSnackbar(
          <Alert severity="info">You must first signup for an account before logging in.</Alert>,
        );
        // Redirect to signup page
        history.push('/signup');
        return;
      }

      setUser(credentials.user);
      history.push('/');
    } catch (error) {
      console.log(error);
    }
  }

  return handleLogin;
}
